import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { vectors } from '../../data/vectors';

const Holder = styled.div`
  &.tanned { display: none; }
  &.light {
    mix-blend-mode: screen;
    svg path { fill: #ee919a; opacity: 0.3; }
  }
  &.honey {
    mix-blend-mode: screen;
    svg path { fill: #e09f58; opacity: 0.3; }
  }
  &.olive {
    mix-blend-mode: multiply;
    svg path { fill: #b0bd8c; opacity: 0.3; }
  }
  &.almond {
    mix-blend-mode: multiply;
    svg path { fill: #b26949; opacity: 0.3; }
  }
  &.dark {
    mix-blend-mode: difference;
    svg path { fill: #695043; opacity: 0.3; }
  }
`;

function SkinTone( {features, currentAvatar}) {
    return (
      <Holder className={features.skintone}>
        { vectors[`${currentAvatar}_faceshape_${features.faceshape}_vector`] }
      </Holder>
    )
}

SkinTone.propTypes = {
  features: PropTypes.object,
  currentAvatar: PropTypes.string.isRequired,
};

export default SkinTone;
